<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="distrbuiRef" :options="item.options" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Distributorsalesreporttable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Distributorsalesreporttable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Distributorsalesreporttable from './components/distributorsalesreporttable.vue'
	import utils from '../../../common/utils'
	import {
		WMSReportDespatchReportList,
		WMSReportDespatchReportExport,
		InventoryClassList,
		ASNVoucherType,
		Status
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Distributorsalesreporttable
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '经销商类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [{
							value: '一级经销商',
							key: '1'
						}, {
							value: '二级经销商',
							key: '2'
						}, ],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '客户',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px'
					},
					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: [

						],
						lablewith: '100px'
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},

					{
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '80px',
						options: []
					},
					{
						inputdata: '',
						title: '发票号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '出库单号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: "",
						title: "开票日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '终端医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '100px',
						options: []
					}
				],
				from: {
					cusGrade: "",
					createOrgName: "",
					vouCode: "",
					cusName: "",
					createTime1: "",
					createTime2: "",
					invClass: "",
					inventory: "",
					voucherType: "",
					verifyTime1: "",
					verifyTime2: "",
					dpDate1: "",
					dpDate2: "",
					InvoiceNo: "",
					VouCode: "",
					SBDate1: "",
					SBDate2: "",
					HospitalName: "",
					Batch: "",
				}
			}
		},
		created() {
			this.$message.warning("请填写搜索条件！");
			//this.wMSReportDespatchReportList()
		},
		mounted() {
			// this.$refs.distrbuiRef[0].modelvalue = this.$refs.distrbuiRef[0].options[1].key
			// console.log(this.from.cusGrade,'this.from.cusGrade');
			this.$refs.distrbuiRef[2].startTime = this.$utils.getFYearDate();
			this.aSNVoucherType()
			this.inventoryClassList()
			this.status();
		},
		methods: {
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.formdata[13].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[13].options.push(obj)
					})
				}
			},
			// 单据类型下拉
			async aSNVoucherType() {
				let {
					code,
					data
				} = await ASNVoucherType({})
				if (code == 0) {
					this.formdata[8].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[8].options.push(obj)
					})
				}
			},
			// 获取产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					try {
						this.formdata[6].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.InvClass,
								value: item.InvClassName
							}
							this.formdata[6].options.push(obj)
						})
					} catch (error) {}
				}
			},
			// 列表
			async wMSReportDespatchReportList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code,
					message
				} = await WMSReportDespatchReportList({
					cusGrade: Number(this.from.cusGrade) == 0 ? null : Number(this.from.cusGrade),
					createOrgName: this.from.createOrgName,
					cusName: this.from.cusName,
					vouCode: this.from.vouCode,
					invClass: this.from.invClass,
					inventory: this.from.inventory,
					voucherType: this.from.voucherType,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					dpDate1: this.from.dpDate1,
					dpDate2: this.from.dpDate2,
					VouCode: this.from.VouCode,
					InvoiceNo: this.from.InvoiceNo,
					HospitalName: this.from.HospitalName,
					SBDate1: this.from.SBDate1,
					SBDate2: this.from.SBDate2,
					Status: this.from.Status,
					Batch: this.from.Batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
				loading.close();
			},
			// 导出
			async wMSReportDespatchReportExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await WMSReportDespatchReportExport({
					cusGrade: Number(this.from.cusGrade),
					createOrgName: this.from.createOrgName,
					cusName: this.from.cusName,
					vouCode: this.from.vouCode,
					invClass: this.from.invClass,
					inventory: this.from.inventory,
					voucherType: this.from.voucherType,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					dpDate1: this.from.dpDate1,
					dpDate2: this.from.dpDate2,
					VouCode: this.from.VouCode,
					SBDate1: this.from.SBDate1,
					SBDate2: this.from.SBDate2,
					InvoiceNo: this.from.InvoiceNo,
					HospitalName: this.from.HospitalName,
					Status: this.from.Status,
					Batch: this.from.Batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
					utils.downloadFile(resexprot, `经销商销售出库报表导出${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.wMSReportDespatchReportExport()
			},
			reset() {
				this.$refs.distrbuiRef.map((item, index) => {
					if (index == 2 || index == 6 || index == 10) {
						item.startTime = ''
						item.endTime = ''
					}
					item.modelvalue = ''
				})
				this.from.HospitalName = '';
			},
			hide() {
				this.showorhide = false
			},
			select() {
				this.pageindex = 1
				try {
					this.from.cusGrade = this.$refs.distrbuiRef[0].modelvalue
					this.from.createOrgName = this.$refs.distrbuiRef[1].modelvalue
					// this.from.vouCode = this.$refs.distrbuiRef[6].modelvalue
					this.from.dpDate1 = this.$refs.distrbuiRef[2].startTime
					this.from.dpDate2 = this.$refs.distrbuiRef[2].endTime
					this.from.cusName = this.$refs.distrbuiRef[3].modelvalue
					this.from.inventory = this.$refs.distrbuiRef[4].modelvalue
					this.from.Batch = this.$refs.distrbuiRef[5].modelvalue
					this.from.invClass = this.$refs.distrbuiRef[6].modelvalue ? this.$refs.distrbuiRef[6].modelvalue.join(
						',') : ''
					this.from.verifyTime1 = this.$refs.distrbuiRef[7].startTime
					this.from.verifyTime2 = this.$refs.distrbuiRef[7].endTime
					this.from.voucherType = this.$refs.distrbuiRef[8].modelvalue
					this.from.InvoiceNo = this.$refs.distrbuiRef[9].modelvalue
					this.from.VouCode = this.$refs.distrbuiRef[10].modelvalue
					this.from.SBDate1 = this.$refs.distrbuiRef[11].startTime
					this.from.SBDate2 = this.$refs.distrbuiRef[11].endTime
					this.from.HospitalName = this.$refs.distrbuiRef[12].modelvalue
					this.from.Status = this.$refs.distrbuiRef[13].modelvalue

					this.wMSReportDespatchReportList()
				} catch (error) {
					this.wMSReportDespatchReportList()
				}
			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.wMSReportDespatchReportList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.wMSReportDespatchReportList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 130px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 48px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 390px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>